import AnalysisChart from '@engine/features/analysis_stats/chart/analysis_stats_by';
import { exists } from '@engine/lib/utility/exists';

function AnalysisStatsChart() {
  function chartExistsIn($element) {
    if ($element.data('chart')) {
      return true;
    }

    return false;
  }

  function create($element) {
    var analysisChart = new AnalysisChart($element);
    analysisChart.render();
    analysisChart.fetchDataset();
    analysisChart.open();
  }

  function toggle($element) {
    $element.data('chart').toggle();
  }

  function closeAll() {
    $('.analysis-stats-chart td > div.open').removeClass('open');
  }

  function initialize() {
    if (!exists($('.analysis_stats .with-chart'))) {
      return;
    }

    $('.with-chart').on('click', function () {
      var $this = $(this);
      closeAll();

      if (chartExistsIn($this)) {
        toggle($this);
      } else {
        create($this);
      }
    });
  }

  return {
    initialize: initialize
  };
}

export default AnalysisStatsChart();